<div class="wrap-break-word px-4 py-2 grid grid-cols-[1fr_auto] gap-1 items-baseline">
  <span class="text-sm pt-1">{{ label() }}</span>
  <span class="pt-1 text-lg text-right">
    {{ priceCt() != null ? (priceCt()! | number:'1.2-2':'de') : '–' }}<span class="text-xs pl-2">ct/kWh</span>
  </span>
</div>
